export default __webpack_public_path__ + "static/opening-aa6fcbbe6d63e46493840f4aa7340829.png";